import React from 'react';

const Auth0Context = React.createContext();

export default Auth0Context;
